import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = "http://127.0.0.1:5000";
Vue.axios.interceptors.request.use(config => {
  const token = localStorage.getItem("user");
  if (token) {
    config.headers["Authorization"] = `${token}`;
  }
  return config;
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
